import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // Asegúrate de tener tu inicialización Firebase aquí
import { useNavigate } from "react-router-dom";

function CrearHub() {
  const [nombre, setNombre] = useState("");
  const [nombrePrivado, setNombrePrivado] = useState("");
  const [hubId, setHubId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setHubId(null);

    const nombreTrim = nombre.trim();
    if (!nombreTrim) {
      setError("El nombre no puede estar vacío.");
      return;
    }
    const nombrePrivadoTrim = nombrePrivado.trim();
    if (!nombrePrivadoTrim) {
      setError("El nombre privado no puede estar vacío.");
      return;
    }

    try {
      setLoading(true);

      // Crear el hub directamente desde aquí
      const docRef = await addDoc(collection(db, "private-hubs"), {
        Nombre: nombreTrim,
        NombrePrivado: nombrePrivadoTrim,
        createdAt: serverTimestamp(),
      });

      setHubId(docRef.id);
      setNombre("");
    } catch (err) {
      console.error("Error al crear el hub:", err);
      setError("Error al crear el hub.");
    } finally {
      setLoading(false);
        // Redirigir al lobby del nuevo hub
        navigate(`/select-hub`);
    }
  };

  return (
    <div className="select-hub-container">
        <div className="select-hub-box">
        <h2 className="select-hub-title">Crear nuevo Hub</h2>
        <form onSubmit={handleSubmit}>
            <input
            type="text"
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="Nombre del hub"
            className="company-selector"
            />
            <input
            type="text"
            value={nombrePrivado}
            onChange={(e) => setNombrePrivado(e.target.value)}
            placeholder="Nombre oculto del hub (siglas)"
            className="company-selector"
            />
            <button
            type="submit"
            className="footer-button"
            disabled={loading}
            >
            {loading ? "Creando..." : "Crear Hub"}
            </button>
        </form>
        {hubId && <p style={{ color: "green" }}>Hub creado con ID: {hubId}</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
    </div>
  );
}

export default CrearHub;
